module.exports = __webpack_public_path__ + "img/extended.5ca71736.png";